import { LastModifiedInfo, SaveBar, formatShortDate, formatTime, useConfirmationDialogContext } from "@shared";

import { useTranslation } from "@/translations";

interface Props {
  lastModifiedAtUtc: Date;
  lastModifiedByUserCode: string;
  // null once that person has left, which is when the bare user code has to stand on its own.
  lastModifiedByName: string | null;
  isDirty: boolean;
  isSaving: boolean;
  onSave: () => void;
  onReset: () => void;
}

// Sits on the page rather than in the tab, so a tab switch cannot take the pending edits with it.
export function DutyScheduleEditBar({
  lastModifiedAtUtc,
  lastModifiedByUserCode,
  lastModifiedByName,
  isDirty,
  isSaving,
  onSave,
  onReset,
}: Props) {
  const { t } = useTranslation();
  const { showConfirmationDialog } = useConfirmationDialogContext();

  const user =
    lastModifiedByName == null ? lastModifiedByUserCode : `${lastModifiedByName} (${lastModifiedByUserCode})`;

  const confirmAndReset = () => {
    showConfirmationDialog({
      dialogTitleText: t("dutySchedule.detail.dataEntry.resetConfirmTitle"),
      dialogText: t("dutySchedule.detail.dataEntry.resetConfirmText"),
      agreeText: t("common.resetChanges"),
      onClose: (confirmed) => {
        if (confirmed) {
          onReset();
        }
      },
    });
  };

  return (
    <SaveBar
      resetLabel={t("common.resetChanges")}
      onReset={confirmAndReset}
      resetDisabled={!isDirty || isSaving}
      saveLabel={t("common.save")}
      saveDisabled={!isDirty || isSaving}
      saveType="button"
      onSave={onSave}
      sx={{ bgcolor: "background.paper" }}
      info={
        <LastModifiedInfo
          text={t("dutySchedule.detail.dataEntry.lastModified", {
            date: formatShortDate(lastModifiedAtUtc),
            time: formatTime(lastModifiedAtUtc),
            user,
          })}
        />
      }
    />
  );
}
